"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Badge = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Badge = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Badge.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-badge';
/**
 * Easily highlight new or unread items by adding a **Badge** to links,
 * standalone text, buttons, and more.
 */
var Badge = exports.Badge = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _a = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(Badge, props)) : props,
    className = _a.className,
    muted = _a.muted,
    otherProps = __rest(_a, ["className", "muted"]);
  var classnames = _bind.default.bind(_Badge.default);
  var classes = classnames(CSS_BLOCK, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--muted"), muted), className);
  return /*#__PURE__*/_react.default.createElement("span", (0, _assign.default)({}, otherProps, {
    className: classes,
    ref: ref
  }));
});
Badge.displayName = 'Badge';
var _default = exports.default = Badge;